import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx="12" cy="12" r="11.5" fill="#fff" stroke="#12033D" /><path fillRule="evenodd" clipRule="evenodd" d="M18.283 7.717a.4.4 0 010 .566l-8 8a.4.4 0 01-.566 0l-4-4.003a.4.4 0 11.566-.566L10 15.434l7.717-7.717a.4.4 0 01.566 0z" fill="#12033D" /></svg>;